import React, { FunctionComponent, useState } from 'react';
import { MdArrowCircleDown } from 'react-icons/md';

import DealService from '../../../services/DealService';

interface FetchTradeInAppraisalButtonProps {
  dealId: string;
  tradeIn: any;
  onChange: (appraisedValue: any) => void;
}
export const FetchTradeInAppraisalButton: FunctionComponent<FetchTradeInAppraisalButtonProps> = props => {
  const { dealId, tradeIn, onChange } = props;

  const [fetchingAppraisedValue, setFetchingAppraisedValue] = useState(false);

  return (
    <button
      className="btn btn-link offer-appraised-value"
      disabled={fetchingAppraisedValue}
      type="button"
      onClick={async () => {
        try {
          setFetchingAppraisedValue(true);

          const appraisedValue = await DealService.getAppraisedValue(
            dealId,
            tradeIn,
          );

          if (appraisedValue) {
            onChange(appraisedValue);
          }
        } finally {
          setFetchingAppraisedValue(false);
        }
      }}
    >
      <MdArrowCircleDown />
      {fetchingAppraisedValue ? 'Fetching value' : 'Pull from VAuto'}
    </button>
  );
};
